export { HighscoresScreen } from './highscores'